import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { editTariffFailed, editTariffSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* editTariff(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/tariffs/${pool?.id}`;
    const dataResponse = yield makeRequest(url, pool, action, 'PATCH', true);
    if (dataResponse.status === OK) {
      yield put(editTariffSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(editTariffFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editTariffFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
